// import React, { useState } from "react";
// import "./ServitorChangePassword.css";

// const ServitorChangePassword = ({ isOpen, onClose, servitorId }) => {
//   const [passwordForm, setPasswordForm] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [showPasswords, setShowPasswords] = useState({
//     old: false,
//     new: false,
//     confirm: false,
//   });
//   const [passwordError, setPasswordError] = useState("");
//   const [passwordSuccess, setPasswordSuccess] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const handlePasswordChange = (field, value) => {
//     setPasswordForm((prev) => ({ ...prev, [field]: value }));
//     setPasswordError("");
//     setPasswordSuccess("");
//   };

//   const togglePasswordVisibility = (field) => {
//     setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setPasswordError("");
//     setPasswordSuccess("");

//     // Validation
//     if (!passwordForm.oldPassword) {
//       setPasswordError("Please enter your current password");
//       setIsLoading(false);
//       return;
//     }

//     if (!passwordForm.newPassword) {
//       setPasswordError("Please enter a new password");
//       setIsLoading(false);
//       return;
//     }

//     if (passwordForm.newPassword.length < 5) {
//       setPasswordError("New password must be at least 5 characters long");
//       setIsLoading(false);
//       return;
//     }

//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       setPasswordError("New passwords do not match");
//       setIsLoading(false);
//       return;
//     }

//     // Commented out additional password requirements for future use
//     /*
//     const { score } = getPasswordStrength(passwordForm.newPassword);
//     if (score < 3) {
//       setPasswordError("Password is too weak. Please choose a stronger password.");
//       setIsLoading(false);
//       return;
//     }
//     */

//     try {
//       // Simulated API call (replace with actual endpoint)
//       await new Promise((resolve) => setTimeout(resolve, 2000));
//       // Example actual API call:
//       // const response = await fetch(`http://localhost:4001/servitors/${servitorId}/change-password`, {
//       //   method: "POST",
//       //   headers: {
//       //     "Content-Type": "application/json",
//       //     Authorization: `Bearer ${localStorage.getItem("token")}`,
//       //   },
//       //   body: JSON.stringify({
//       //     oldPassword: passwordForm.oldPassword,
//       //     newPassword: passwordForm.newPassword,
//       //   }),
//       // });
//       // if (!response.ok) throw new Error("Failed to change password");

//       setPasswordSuccess("Password changed successfully!");
//       setTimeout(() => {
//         onClose();
//         setPasswordForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
//         setPasswordSuccess("");
//       }, 1500);
//     } catch (error) {
//       setPasswordError("Failed to change password. Please try again.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="ServitorChangePassword-modal-overlay"> {/* CHANGE: Removed onClick={onClose} */}
//       <div className="ServitorChangePassword-modal-content" onClick={(e) => e.stopPropagation()}>
//         <div className="ServitorChangePassword-modal-header">
//           <h2>
//             <i className="fas fa-lock"></i>
//             Change Password
//           </h2>
//           <button className="ServitorChangePassword-modal-close" onClick={onClose}>
//             <i className="fas fa-times"></i>
//           </button>
//         </div>
//         <form onSubmit={handlePasswordSubmit}>
//           <div className="ServitorChangePassword-modal-body">
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="oldPassword">Current Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.old ? "text" : "password"}
//                   id="oldPassword"
//                   value={passwordForm.oldPassword}
//                   onChange={(e) => handlePasswordChange("oldPassword", e.target.value)}
//                   placeholder="Enter your current password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("old")}
//                 >
//                   <i className={`fas ${showPasswords.old ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//             </div>
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="newPassword">New Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.new ? "text" : "password"}
//                   id="newPassword"
//                   value={passwordForm.newPassword}
//                   onChange={(e) => handlePasswordChange("newPassword", e.target.value)}
//                   placeholder="Enter your new password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("new")}
//                 >
//                   <i className={`fas ${showPasswords.new ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//             </div>
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="confirmPassword">Confirm New Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.confirm ? "text" : "password"}
//                   id="confirmPassword"
//                   value={passwordForm.confirmPassword}
//                   onChange={(e) => handlePasswordChange("confirmPassword", e.target.value)}
//                   placeholder="Confirm your new password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("confirm")}
//                 >
//                   <i className={`fas ${showPasswords.confirm ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//               {passwordForm.confirmPassword && passwordForm.newPassword !== passwordForm.confirmPassword && (
//                 <div className="ServitorChangePassword-error-message">
//                   <i className="fas fa-exclamation-triangle"></i>
//                   Passwords do not match
//                 </div>
//               )}
//             </div>
//             {passwordError && (
//               <div className="ServitorChangePassword-error-message">
//                 <i className="fas fa-exclamation-triangle"></i>
//                 {passwordError}
//               </div>
//             )}
//             {passwordSuccess && (
//               <div className="ServitorChangePassword-success-message">
//                 <i className="fas fa-check-circle"></i>
//                 {passwordSuccess}
//               </div>
//             )}
//           </div>
//           <div className="ServitorChangePassword-modal-footer">
//             <button
//               type="button"
//               className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-secondary"
//               onClick={onClose}
//               disabled={isLoading}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-primary"
//               disabled={
//                 isLoading ||
//                 !passwordForm.oldPassword ||
//                 !passwordForm.newPassword ||
//                 !passwordForm.confirmPassword ||
//                 passwordForm.newPassword !== passwordForm.confirmPassword
//               }
//             >
//               {isLoading && <span className="ServitorChangePassword-loading-spinner"></span>}
//               {isLoading ? "Updating..." : "Change Password"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ServitorChangePassword;






// ***** All Checked and working fine (26-6-25) ***** //

// import React, { useState } from "react";
// import axios from "axios";
// import "./ServitorChangePassword.css";

// const ServitorChangePassword = ({ isOpen, onClose, servitorId }) => {
//   const [passwordForm, setPasswordForm] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [showPasswords, setShowPasswords] = useState({
//     old: false,
//     new: false,
//     confirm: false,
//   });
//   const [passwordError, setPasswordError] = useState("");
//   const [passwordSuccess, setPasswordSuccess] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const handlePasswordChange = (field, value) => {
//     setPasswordForm((prev) => ({ ...prev, [field]: value }));
//     setPasswordError("");
//     setPasswordSuccess("");
//   };

//   const togglePasswordVisibility = (field) => {
//     setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
//   };

//   const handlePasswordSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setPasswordError("");
//     setPasswordSuccess("");

//     // 1) Basic form validation:
//     if (!passwordForm.oldPassword) {
//       setPasswordError("Please enter your current password");
//       setIsLoading(false);
//       return;
//     }
//     if (!passwordForm.newPassword) {
//       setPasswordError("Please enter a new password");
//       setIsLoading(false);
//       return;
//     }
//     if (passwordForm.newPassword.length < 5) {
//       setPasswordError("New password must be at least 5 characters long");
//       setIsLoading(false);
//       return;
//     }
//     if (passwordForm.newPassword !== passwordForm.confirmPassword) {
//       setPasswordError("New passwords do not match");
//       setIsLoading(false);
//       return;
//     }

//     try {
//       // 2) Call your new endpoint:
//       const token = localStorage.getItem("token");
//       const response = await axios.post(
//         `http://localhost:4001/servitors/${servitorId}/change-password`,
//         {
//           oldPassword: passwordForm.oldPassword,
//           newPassword: passwordForm.newPassword,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         setPasswordSuccess("Password changed successfully!");
//         setTimeout(() => {
//           onClose();
//           setPasswordForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
//           setPasswordSuccess("");
//         }, 3000);
//       } else {
//         setPasswordError("Failed to change password. Please try again.");
//       }
//     } catch (err) {
//       if (err.response && err.response.data && err.response.data.error) {
//         setPasswordError(err.response.data.error);
//       } else {
//         setPasswordError("Failed to change password. Please try again.");
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="ServitorChangePassword-modal-overlay">
//       <div className="ServitorChangePassword-modal-content" onClick={(e) => e.stopPropagation()}>
//         <div className="ServitorChangePassword-modal-header">
//           <h2>
//             <i className="fas fa-lock"></i> Change Password
//           </h2>
//           <button className="ServitorChangePassword-modal-close" onClick={onClose}>
//             <i className="fas fa-times"></i>
//           </button>
//         </div>

//         <form onSubmit={handlePasswordSubmit}>
//           <div className="ServitorChangePassword-modal-body">
//             {/* Old Password */}
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="oldPassword">Current Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.old ? "text" : "password"}
//                   id="oldPassword"
//                   value={passwordForm.oldPassword}
//                   onChange={(e) => handlePasswordChange("oldPassword", e.target.value)}
//                   placeholder="Enter your current password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("old")}
//                 >
//                   <i className={`fas ${showPasswords.old ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//             </div>

//             {/* New Password */}
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="newPassword">New Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.new ? "text" : "password"}
//                   id="newPassword"
//                   value={passwordForm.newPassword}
//                   onChange={(e) => handlePasswordChange("newPassword", e.target.value)}
//                   placeholder="Enter your new password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("new")}
//                 >
//                   <i className={`fas ${showPasswords.new ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//             </div>

//             {/* Confirm Password */}
//             <div className="ServitorChangePassword-form-group">
//               <label htmlFor="confirmPassword">Confirm New Password</label>
//               <div className="ServitorChangePassword-password-input-container">
//                 <input
//                   type={showPasswords.confirm ? "text" : "password"}
//                   id="confirmPassword"
//                   value={passwordForm.confirmPassword}
//                   onChange={(e) => handlePasswordChange("confirmPassword", e.target.value)}
//                   placeholder="Confirm your new password"
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="ServitorChangePassword-password-toggle"
//                   onClick={() => togglePasswordVisibility("confirm")}
//                 >
//                   <i className={`fas ${showPasswords.confirm ? "fa-eye-slash" : "fa-eye"}`}></i>
//                 </button>
//               </div>
//               {passwordForm.confirmPassword && passwordForm.newPassword !== passwordForm.confirmPassword && (
//                 <div className="ServitorChangePassword-error-message">
//                   <i className="fas fa-exclamation-triangle"></i> Passwords do not match
//                 </div>
//               )}
//             </div>

//             {passwordError && (
//               <div className="ServitorChangePassword-error-message">
//                 <i className="fas fa-exclamation-triangle"></i> {passwordError}
//               </div>
//             )}
//             {passwordSuccess && (
//               <div className="ServitorChangePassword-success-message">
//                 <i className="fas fa-check-circle"></i> {passwordSuccess}
//               </div>
//             )}
//           </div>

//           <div className="ServitorChangePassword-modal-footer">
//             <button
//               type="button"
//               className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-secondary"
//               onClick={onClose}
//               disabled={isLoading}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-primary"
//               disabled={
//                 isLoading ||
//                 !passwordForm.oldPassword ||
//                 !passwordForm.newPassword ||
//                 !passwordForm.confirmPassword ||
//                 passwordForm.newPassword !== passwordForm.confirmPassword
//               }
//             >
//               {/* {isLoading ? (
//                 <span className="ServitorChangePassword-loading-spinner"></span>
//               ) : (
//                 "Change Password"
//               )} */}
//               {isLoading && <span className="ServitorChangePassword-loading-spinner"></span>}
//                {isLoading ? "Updating..." : "Change Password"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ServitorChangePassword;

// ***** Upper code All Checked and working fine (26-6-25) ***** //




// ***** Add Translator EN BN (26-6-25) ***** //


import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import "./ServitorChangePassword.css";
import { URL } from "../../../../config";

const ServitorChangePassword = ({ isOpen, onClose, servitorId }) => {
  const { t } = useTranslation("servitor");
  const [passwordForm, setPasswordForm] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [showPasswords, setShowPasswords] = useState({
    old: false,
    new: false,
    confirm: false,
  });
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordChange = (field, value) => {
    setPasswordForm((prev) => ({ ...prev, [field]: value }));
    setPasswordError("");
    setPasswordSuccess("");
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setPasswordError("");
    setPasswordSuccess("");

    // 1) Basic form validation:
    if (!passwordForm.oldPassword) {
      // setPasswordError("Please enter your current password");
      setPasswordError(t("servitorChangePassword.currentPasswordRequired"));
      setIsLoading(false);
      return;
    }
    if (!passwordForm.newPassword) {
      // setPasswordError("Please enter a new password");
      setPasswordError(t("servitorChangePassword.newPasswordRequired"));
      setIsLoading(false);
      return;
    }
    if (passwordForm.newPassword.length < 5) {
      // setPasswordError("New password must be at least 5 characters long");
      setPasswordError(t("servitorChangePassword.newPasswordMinLength"));
      setIsLoading(false);
      return;
    }
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      // setPasswordError("New passwords do not match");
      setPasswordError(t("servitorChangePassword.passwordsDoNotMatch"));
      setIsLoading(false);
      return;
    }

    try {
      // 2) Call your new endpoint:
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${URL}/servitors/${servitorId}/change-password`,
        {
          oldPassword: passwordForm.oldPassword,
          newPassword: passwordForm.newPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        // setPasswordSuccess("Password changed successfully!");
        setPasswordSuccess(t("servitorChangePassword.passwordChangedSuccessfully"));
        setTimeout(() => {
          onClose();
          setPasswordForm({ oldPassword: "", newPassword: "", confirmPassword: "" });
          setPasswordSuccess("");
        }, 3000);
      } else {
        // setPasswordError("Failed to change password. Please try again.");
        setPasswordError(t("servitorChangePassword.failedToChangePassword"));
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setPasswordError(err.response.data.error);
      } else {
        // setPasswordError("Failed to change password. Please try again.");
        setPasswordError(t("servitorChangePassword.failedToChangePassword"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="ServitorChangePassword-modal-overlay">
      <div className="ServitorChangePassword-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="ServitorChangePassword-modal-header">
          <h2>
            {/* <i className="fas fa-lock"></i> Change Password */}
            <i className="fas fa-lock"></i> {t("servitorChangePassword.title")}
          </h2>
          <button className="ServitorChangePassword-modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handlePasswordSubmit}>
          <div className="ServitorChangePassword-modal-body">
            {/* Old Password */}
            <div className="ServitorChangePassword-form-group">
              {/* <label htmlFor="oldPassword">Current Password</label> */}
              <label htmlFor="oldPassword">{t("servitorChangePassword.currentPasswordLabel")}</label>
              <div className="ServitorChangePassword-password-input-container">
                <input
                  type={showPasswords.old ? "text" : "password"}
                  id="oldPassword"
                  value={passwordForm.oldPassword}
                  onChange={(e) => handlePasswordChange("oldPassword", e.target.value)}
                  // placeholder="Enter your current password"
                  placeholder={t("servitorChangePassword.currentPasswordPlaceholder")}
                  required
                />
                <button
                  type="button"
                  className="ServitorChangePassword-password-toggle"
                  onClick={() => togglePasswordVisibility("old")}
                >
                  <i className={`fas ${showPasswords.old ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
            </div>

            {/* New Password */}
            <div className="ServitorChangePassword-form-group">
              {/* <label htmlFor="newPassword">New Password</label> */}
              <label htmlFor="newPassword">{t("servitorChangePassword.newPasswordLabel")}</label>
              <div className="ServitorChangePassword-password-input-container">
                <input
                  type={showPasswords.new ? "text" : "password"}
                  id="newPassword"
                  value={passwordForm.newPassword}
                  onChange={(e) => handlePasswordChange("newPassword", e.target.value)}
                  // placeholder="Enter your new password"
                  placeholder={t("servitorChangePassword.newPasswordPlaceholder")}
                  required
                />
                <button
                  type="button"
                  className="ServitorChangePassword-password-toggle"
                  onClick={() => togglePasswordVisibility("new")}
                >
                  <i className={`fas ${showPasswords.new ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="ServitorChangePassword-form-group">
              {/* <label htmlFor="confirmPassword">Confirm New Password</label> */}
              <label htmlFor="confirmPassword">{t("servitorChangePassword.confirmPasswordLabel")}</label>
              <div className="ServitorChangePassword-password-input-container">
                <input
                  type={showPasswords.confirm ? "text" : "password"}
                  id="confirmPassword"
                  value={passwordForm.confirmPassword}
                  onChange={(e) => handlePasswordChange("confirmPassword", e.target.value)}
                  // placeholder="Confirm your new password"
                  placeholder={t("servitorChangePassword.confirmPasswordPlaceholder")}
                  required
                />
                <button
                  type="button"
                  className="ServitorChangePassword-password-toggle"
                  onClick={() => togglePasswordVisibility("confirm")}
                >
                  <i className={`fas ${showPasswords.confirm ? "fa-eye-slash" : "fa-eye"}`}></i>
                </button>
              </div>
              {passwordForm.confirmPassword && passwordForm.newPassword !== passwordForm.confirmPassword && (
                <div className="ServitorChangePassword-error-message">
                  {/* <i className="fas fa-exclamation-triangle"></i> Passwords do not match */}
                  <i className="fas fa-exclamation-triangle"></i> {t("servitorChangePassword.passwordsDoNotMatch")}
                </div>
              )}
            </div>

            {passwordError && (
              <div className="ServitorChangePassword-error-message">
                <i className="fas fa-exclamation-triangle"></i> {passwordError}
              </div>
            )}
            {passwordSuccess && (
              <div className="ServitorChangePassword-success-message">
                <i className="fas fa-check-circle"></i> {passwordSuccess}
              </div>
            )}
          </div>

          <div className="ServitorChangePassword-modal-footer">
            <button
              type="button"
              className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-secondary"
              onClick={onClose}
              disabled={isLoading}
            >
              {/* Cancel */}
              {t("servitorChangePassword.cancelButton")}
            </button>
            <button
              type="submit"
              className="ServitorChangePassword-modal-btn ServitorChangePassword-modal-btn-primary"
              disabled={
                isLoading ||
                !passwordForm.oldPassword ||
                !passwordForm.newPassword ||
                !passwordForm.confirmPassword ||
                passwordForm.newPassword !== passwordForm.confirmPassword
              }
            >
              {/* {isLoading ? (
                <span className="ServitorChangePassword-loading-spinner"></span>
              ) : (
                "Change Password"
              )} */}
              {isLoading && <span className="ServitorChangePassword-loading-spinner"></span>}
               {/* {isLoading ? "Updating..." : "Change Password"} */}
               {isLoading ? t("servitorChangePassword.updating") : t("servitorChangePassword.changePasswordButton")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ServitorChangePassword;
